var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class SortableItemUI {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get sortableItem() {
        return this.parent;
    }
    get question() {
        return this.sortableItem.question;
    }
    get isItemInAnyCorrectPlace() {
        let correctStateIndex = -1;
        for (let i = 0; i < this.question.sortableStore.successStates.length && correctStateIndex === -1; i++) {
            const successState = this.question.sortableStore.successStates[i];
            const found = successState.sortableItemStates.find((item) => item.sortableItemId === this.sortableItem.id_string &&
                item.droppableId === this.sortableItem.droppableId &&
                (item.indexInDroppable === -1 || item.indexInDroppable === this.sortableItem.indexInDroppable));
            if (found)
                correctStateIndex = i;
        }
        return correctStateIndex !== -1;
    }
    get isItemInStartingPlace() {
        const found = this.question.sortableStore.startState.sortableItemStates.find((s) => s.sortableItemId === this.sortableItem.id_string);
        if (!found)
            return false;
        return (this.sortableItem.droppableId === found.droppableId &&
            this.sortableItem.indexInDroppable === found.indexInDroppable);
    }
    get isItemInStartingDroppable() {
        const found = this.question.sortableStore.startState.sortableItemStates.find((s) => s.sortableItemId === this.sortableItem.id_string);
        if (!found)
            return false;
        return this.sortableItem.droppableId === found.droppableId;
    }
    get isItemInAnyWrongPlace() {
        return !this.isItemInAnyCorrectPlace && !this.isItemInStartingPlace;
    }
    get isItemInOtherDroppableAndWrongPlace() {
        return !this.isItemInStartingDroppable && !this.isItemInAnyCorrectPlace;
    }
}
__decorate([
    computed
], SortableItemUI.prototype, "isItemInAnyCorrectPlace", null);
__decorate([
    computed
], SortableItemUI.prototype, "isItemInStartingPlace", null);
__decorate([
    computed
], SortableItemUI.prototype, "isItemInStartingDroppable", null);
__decorate([
    computed
], SortableItemUI.prototype, "isItemInAnyWrongPlace", null);
__decorate([
    computed
], SortableItemUI.prototype, "isItemInOtherDroppableAndWrongPlace", null);
